export default __webpack_public_path__ + "31eaa61a2968f4dcdd981e05b18d835e.ttf";